import { render, staticRenderFns } from "./PromotionsRetailerPage.vue?vue&type=template&id=097eab6a&scoped=true"
import script from "./PromotionsRetailerPage.vue?vue&type=script&lang=js"
export * from "./PromotionsRetailerPage.vue?vue&type=script&lang=js"
import style0 from "./PromotionsRetailerPage.vue?vue&type=style&index=0&id=097eab6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097eab6a",
  null
  
)

export default component.exports